module.exports = __webpack_public_path__ + "img/zhgl.73a8acaa.svg";